import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-8 text-destructive" data-testid="forbidden">
        You do not have permission to view this page.
      </div>
    );
  }
  return children;
}
